import Icon from '../components/Icon.vue'

Icon.register({
  globe: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M336.5 160C322 70.7 287.8 8 248 8S174 70.7 159.5 160H336.5zM152 256C152 278.2 153.2 299.5 155.3 320H340.6C342.7 299.5 343.9 278.2 343.9 256S342.7 212.5 340.6 192H155.3C153.2 212.5 152 233.8 152 256zM476.7 160C448.1 92.1 390.2 39.6 318.7 18.4 343.1 52.2 359.9 103.1 368.7 160H476.7zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160H127.3C136 103.1 152.8 52.2 177.2 18.4zM487.4 192H372.7C374.8 213 376 234.5 376 256S374.8 299 372.7 320H487.3C492.8 299.5 495.9 278.2 495.9 256S492.8 212.5 487.4 192zM120 256C120 234.5 121.2 213 123.3 192H8.6C3.2 212.5 0 233.8 0 256S3.2 299.5 8.6 320H123.2C121.2 299 120 277.5 120 256zM159.5 352C174 441.3 208.2 504 248 504S322 441.3 336.5 352H159.5zM318.8 493.6C390.2 472.4 448.2 419.9 476.8 352H368.8C360 408.9 343.2 459.8 318.8 493.6zM19.3 352C47.9 419.9 105.8 472.4 177.3 493.6 152.9 459.8 136.1 408.9 127.3 352H19.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/globe.js
// module id = 5/Mn
// module chunks = 144